module.exports = __webpack_public_path__ + "static/media/IT.dd5fc033.png";